<div class="info-modal-root">

    <!-- ═══════════════ HEADER ═══════════════ -->
    <div class="info-header">
        <div class="header-backdrop"></div>
        <div class="header-content">
            <button class="back-btn" (click)="dismiss()">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </button>
            <div class="header-text">
                <span class="header-label">{{ subtitle ? subtitle : 'Información Detallada' }}</span>
                <h1 class="header-title">{{ title }}</h1>
            </div>
            <div class="header-actions">
                <button class="header-action-btn" (click)="compartirResumenComoImagen()" [disabled]="exporting" title="Compartir como imagen">
                    <ion-spinner *ngIf="exporting" name="crescent"></ion-spinner>
                    <ion-icon *ngIf="!exporting" name="share-social-outline"></ion-icon>
                </button>
            </div>
        </div>
        <div class="header-wave">
            <svg viewBox="0 0 1200 60" preserveAspectRatio="none">
                <path d="M0,30 C300,60 900,0 1200,30 L1200,60 L0,60 Z" fill="var(--body-bg)"/>
            </svg>
        </div>
    </div>

    <!-- ═══════════════ CONTENT ═══════════════ -->
    <ion-content class="info-content">
        <div class="sections-wrap premium-list-container" #exportArea id="export-area">

            <div class="info-section"
                 *ngFor="let section of sections; let i = index"
                 [style.animation-delay]="(i * 70) + 'ms'">

                <!-- Section label -->
                <div class="section-label">
                    <span class="label-line"></span>
                    <span class="label-text">{{ section.title }}</span>
                    <span class="label-line"></span>
                </div>

                <!-- Section card -->
                <div class="section-card">
                    <div class="info-row"
                         *ngFor="let item of section.items; let last = last"
                         [ngClass]="item.rowClass"
                         [class.last-row]="last">

                        <!-- Standard horizontal row -->
                        <ng-container *ngIf="!item.rowClass || item.rowClass === 'row-sub-detail' || item.rowClass === 'row-sub-sub-detail'">
                            <div class="row-icon-wrap" [class.icon-positive]="item.valueClass?.includes('positive')"
                                                       [class.icon-negative]="item.valueClass?.includes('negative')"
                                                       [class.icon-emphasis]="item.valueClass?.includes('emphasis')"
                                                       [style.color]="item.iconColor || null">
                                <ion-icon [name]="item.icon || 'information-circle-outline'"></ion-icon>
                            </div>
                            <div class="row-body">
                                <span class="row-label">{{ item.label }}</span>
                                <span class="row-value" [ngClass]="item.valueClass">{{ item.value }}</span>
                            </div>
                        </ng-container>

                        <!-- Subtotal row -->
                        <ng-container *ngIf="item.rowClass === 'row-subtotal'">
                            <div class="subtotal-left">
                                <div class="subtotal-sigma">∑</div>
                            </div>
                            <div class="row-body">
                                <span class="row-label subtotal-formula">{{ item.sublabel }}</span>
                                <span class="row-value subtotal-value" [ngClass]="item.valueClass">{{ item.value }}</span>
                            </div>
                        </ng-container>

                        <!-- Stacked (description) row -->
                        <ng-container *ngIf="item.rowClass === 'row-stacked'">
                            <div class="stacked-header">
                                <ion-icon [name]="item.icon || 'document-outline'"></ion-icon>
                                <span class="row-label">{{ item.label }}</span>
                            </div>
                            <p class="stacked-value">{{ item.value }}</p>
                        </ng-container>

                        <!-- Custom turnos/shifts card -->
                        <ng-container *ngIf="item.rowClass === 'row-custom-shifts-card'">
                            <div class="custom-shifts-card">
                                <div class="shift-chip diurno">
                                    <ion-icon name="sunny-outline"></ion-icon>
                                    <span class="sc-count">{{ item.extraData?.diurnos || 0 }}</span>
                                    <span class="sc-label">Días (Diurno)</span>
                                </div>
                                <div class="shift-chip nocturno">
                                    <ion-icon name="moon-outline"></ion-icon>
                                    <span class="sc-count">{{ item.extraData?.nocturnos || 0 }}</span>
                                    <span class="sc-label">Noches (Nocturno)</span>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Custom worked day card matching RESUMEN POR TRABAJADOR style -->
                        <ng-container *ngIf="item.rowClass === 'row-custom-day-card'">
                            <div class="resumen-trab-card-clone">
                                <!-- Header: Avatar + Fecha + Costo Neto -->
                                <div class="rtc-header">
                                    <div class="rtc-avatar-calendar">
                                        <ion-icon name="calendar-outline"></ion-icon>
                                    </div>
                                    <span class="rtc-nombre">{{ item.label }}</span>
                                    <span class="rtc-neto">{{ item.value }}</span>
                                </div>

                                <!-- Turnos: diurnos / nocturnos count for this day -->
                                <div class="rtc-turnos">
                                    <div class="turno-chip diurno">
                                        <ion-icon name="sunny-outline"></ion-icon>
                                        <span class="tc-count">{{ item.extraData?.diurnos || 0 }}</span>
                                        <span class="tc-label">{{ (item.extraData?.diurnos === 1) ? 'diurno' : 'diurnos' }}</span>
                                    </div>
                                    <div class="turno-chip nocturno">
                                        <ion-icon name="moon-outline"></ion-icon>
                                        <span class="tc-count">{{ item.extraData?.nocturnos || 0 }}</span>
                                        <span class="tc-label">{{ (item.extraData?.nocturnos === 1) ? 'nocturno' : 'nocturnos' }}</span>
                                    </div>
                                </div>

                                <!-- Detalle: count of workers -->
                                <div class="rtc-detalles">
                                    <div class="det-chip workers">
                                        <ion-icon name="people-outline"></ion-icon>
                                        <span>{{ item.extraData?.totalWorkers || 0 }} {{ (item.extraData?.totalWorkers === 1) ? 'Trabajador' : 'Trabajadores' }}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Custom Day Detail Card (Detalle Diario Elegante) -->
                        <ng-container *ngIf="item.rowClass === 'row-custom-day-detail'">
                            <div class="day-detail-card" [class.no-activity]="!item.extraData?.tieneActividad">
                                <!-- Header del Día -->
                                <div class="ddc-header">
                                    <div class="ddc-date-badge" [class.active]="item.extraData?.tieneActividad">
                                        <ion-icon [name]="item.extraData?.tieneActividad ? 'calendar' : 'calendar-outline'"></ion-icon>
                                        <span class="ddc-day-name">{{ item.extraData?.diaNombre }}</span>
                                        <span class="ddc-day-num">{{ item.extraData?.diaNum }}</span>
                                    </div>

                                    <div class="ddc-header-right">
                                        <div class="ddc-turns-count" *ngIf="item.extraData?.tieneActividad && item.extraData?.turnos?.length > 1">
                                            <span class="count-pill">
                                                {{ item.extraData?.turnos?.length }} Turnos
                                            </span>
                                        </div>
                                        <div class="ddc-total-badge" [class.zero]="!item.extraData?.tieneActividad">
                                            <span class="dtb-label">Total Día</span>
                                            <span class="dtb-monto">{{ item.value }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Lista de turnos / lugares del día -->
                                <div class="ddc-body" *ngIf="item.extraData?.tieneActividad && item.extraData?.turnos?.length > 0">
                                    <div class="ddc-turno-block" *ngFor="let t of item.extraData?.turnos; let isLast = last" [class.has-border]="!isLast">
                                        <!-- Línea 1: Turno + Nombre del Lugar -->
                                        <div class="dtr-top-line">
                                            <span class="dtr-shift-tag" [ngClass]="t.turno === 'N' ? 'nocturno' : 'diurno'">
                                                <ion-icon [name]="t.turno === 'N' ? 'moon-outline' : 'sunny-outline'"></ion-icon>
                                                {{ t.turno === 'N' ? 'Nocturno' : 'Diurno' }}
                                            </span>
                                            <span class="dtr-lugar">{{ t.lugar }}</span>
                                        </div>

                                        <!-- Línea 2: Desglose financiero (Base, Extra, Descuento) y Nota si aplica -->
                                        <div class="dtr-bottom-line">
                                            <div class="dtr-financial-chips">
                                                <div class="df-chip base" title="Monto Base">
                                                    <span class="dfc-lbl">Base:</span>
                                                    <span class="dfc-val">{{ t.montoFormatted }}</span>
                                                </div>
                                                <div class="df-chip extra" *ngIf="t.extra > 0" title="Extras">
                                                    <span class="dfc-lbl">Extra:</span>
                                                    <span class="dfc-val">{{ t.extraFormatted }}</span>
                                                </div>
                                                <div class="df-chip desc" *ngIf="t.descuento > 0" title="Descuento">
                                                    <span class="dfc-lbl">Desc:</span>
                                                    <span class="dfc-val">{{ t.descuentoFormatted }}</span>
                                                </div>
                                            </div>

                                            <div class="dtr-nota-box" *ngIf="t.nota">
                                                <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
                                                <span>{{ t.nota }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Sin actividad -->
                                <div class="ddc-empty-day" *ngIf="!item.extraData?.tieneActividad">
                                    <ion-icon name="remove-circle-outline"></ion-icon>
                                    <span>Sin actividad registrada</span>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Accordion description row -->
                        <ng-container *ngIf="item.rowClass === 'row-accordion-description'">
                            <div class="accordion-desc-wrap" (click)="item.expanded = !item.expanded; $event.stopPropagation()">
                                <div class="accordion-header">
                                    <div class="row-icon-wrap">
                                        <ion-icon [name]="item.icon || 'document-text-outline'"></ion-icon>
                                    </div>
                                    <div class="row-body">
                                        <span class="row-label">{{ item.label }}</span>
                                        <span class="row-value summary-text" *ngIf="!item.expanded">
                                            {{ getSummary(item.value) }}
                                        </span>
                                    </div>
                                    <div class="arrow-wrap">
                                        <ion-icon [name]="item.expanded ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                                    </div>
                                </div>
                                <div class="accordion-content" [class.expanded]="item.expanded">
                                    <p class="full-text">{{ item.value }}</p>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Custom worker card matching RESUMEN POR TRABAJADOR style -->
                        <ng-container *ngIf="item.rowClass === 'row-custom-worker-card'">
                            <div class="resumen-trab-card-clone">
                                <!-- Header: Avatar + Nombre + Costo Neto -->
                                <div class="rtc-header">
                                    <div class="rtc-avatar">
                                        {{ item.label.charAt(0) }}
                                    </div>
                                    <span class="rtc-nombre">{{ item.label }}</span>
                                    <div class="rtc-neto-badge">
                                        <span class="rnb-label">Total a Pagar</span>
                                        <span class="rnb-monto">{{ item.value }}</span>
                                    </div>
                                </div>

                                <!-- Turnos: diurnos / nocturnos count for this worker -->
                                <div class="rtc-turnos">
                                    <div class="turno-chip diurno">
                                        <ion-icon name="sunny-outline"></ion-icon>
                                        <span class="tc-count">{{ item.extraData?.diurnos || 0 }}</span>
                                        <span class="tc-label">{{ (item.extraData?.diurnos === 1) ? 'día' : 'días' }}</span>
                                    </div>
                                    <div class="turno-chip nocturno">
                                        <ion-icon name="moon-outline"></ion-icon>
                                        <span class="tc-count">{{ item.extraData?.nocturnos || 0 }}</span>
                                        <span class="tc-label">{{ (item.extraData?.nocturnos === 1) ? 'noche' : 'noches' }}</span>
                                    </div>
                                </div>

                                <!-- Desglose financiero (si está presente) -->
                                <div class="rtc-financiero" *ngIf="item.extraData?.monto">
                                    <div class="fin-chip base">
                                        <ion-icon name="wallet-outline"></ion-icon>
                                        <span class="fc-label">Monto</span>
                                        <span class="fc-valor">{{ item.extraData?.monto || '$0.00' }}</span>
                                    </div>
                                    <div class="fin-chip extra" [class.fin-zero]="!item.extraData?.extraNum || item.extraData?.extraNum === 0">
                                        <ion-icon name="trending-up-outline"></ion-icon>
                                        <span class="fc-label">Extra</span>
                                        <span class="fc-valor">{{ item.extraData?.extra || '$0.00' }}</span>
                                    </div>
                                    <div class="fin-chip descuento" [class.fin-zero]="!item.extraData?.descuentoNum || item.extraData?.descuentoNum === 0">
                                        <ion-icon name="trending-down-outline"></ion-icon>
                                        <span class="fc-label">Desc.</span>
                                        <span class="fc-valor">{{ item.extraData?.descuento || '$0.00' }}</span>
                                    </div>
                                </div>

                                <!-- Detalle: Días activos (si no hay desglose financiero) -->
                                <div class="rtc-detalles" *ngIf="!item.extraData?.monto && item.extraData?.totalDays">
                                    <div class="det-chip workers">
                                        <ion-icon name="calendar-outline"></ion-icon>
                                        <span>{{ item.extraData?.totalDays || 0 }} {{ (item.extraData?.totalDays === 1) ? 'Día Activo' : 'Días Activos' }}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Custom single card containing list of all workers with total days -->
                        <ng-container *ngIf="item.rowClass === 'row-custom-workers-list-card'">
                            <div class="resumen-trab-card-clone">
                                <div class="rtc-header" style="border-bottom: 1.5px dashed var(--row-sep); padding-bottom: 10px; margin-bottom: 8px;">
                                    <div class="rtc-avatar-calendar">
                                        <ion-icon name="people-outline"></ion-icon>
                                    </div>
                                    <span class="rtc-nombre">Personal Asignado</span>
                                    <span class="rtc-neto" style="font-size: 0.9rem; color: var(--brand-from);">
                                        {{ item.extraData?.workers?.length || 0 }} {{ (item.extraData?.workers?.length === 1) ? 'Persona' : 'Personas' }}
                                    </span>
                                </div>

                                <div class="workers-list-mini" style="display: flex; flex-direction: column; gap: 8px;">
                                    <div class="worker-mini-row" *ngFor="let w of item.extraData?.workers" style="display: flex; align-items: center; justify-content: space-between; font-size: 0.85rem; padding: 4px 0;">
                                        <div style="display: flex; align-items: center; gap: 8px;">
                                            <div style="width: 24px; height: 24px; border-radius: 6px; background: rgba(30, 60, 114, 0.1); color: var(--brand-from); display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 0.75rem;">
                                                {{ w.nombre.charAt(0) }}
                                            </div>
                                            <span style="font-weight: 600; color: var(--text-main);">{{ w.nombre }}</span>
                                        </div>
                                        <span style="font-size: 0.78rem; font-weight: 700; color: var(--brand-from); background: #f0f4f8; padding: 2px 8px; border-radius: 6px;">
                                            {{ w.dias }} {{ w.dias === 1 ? 'Día' : 'Días' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                    </div>
                </div>

            </div>

        </div>
    </ion-content>

</div>
